const ContactPage = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Contato</h1>
      <div className="bg-surface shadow overflow-hidden sm:rounded-lg">
        <div className="px-4 py-5 sm:px-6">
          <h3 className="text-lg leading-6 font-medium text-fg">
            Entre em Contato
          </h3>
        </div>
        <div className="border-t border-line px-4 py-5 sm:p-0">
          <dl className="sm:divide-y sm:divide-gray-200">
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-fg-muted">Endereço</dt>
              <dd className="mt-1 text-sm text-fg sm:mt-0 sm:col-span-2">
                Rua Exemplo, 123<br />
                Bairro Centro<br />
                Cidade Exemplo, 00000-000
              </dd>
            </div>
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-fg-muted">Telefone</dt>
              <dd className="mt-1 text-sm text-fg sm:mt-0 sm:col-span-2">
                (00) 0000-0000
              </dd>
            </div>
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-fg-muted">E-mail</dt>
              <dd className="mt-1 text-sm text-fg sm:mt-0 sm:col-span-2">
                contact@example.com
              </dd>
            </div>
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-fg-muted">Horário de Atendimento</dt>
              <dd className="mt-1 text-sm text-fg sm:mt-0 sm:col-span-2">
                Segunda a Sexta, das 7h30 às 18h30
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;